import { useEffect, useState } from "react";
import Base from "../../Base/views/Base";
import Box from '@mui/material/Box';
import { Button, Card, Grid, Typography, List, ListItem, ListItemText, Select, MenuItem, Tooltip } from "@mui/material";
import Popup from "../../components/Popup";
import Cart from "./OrderItems";
import Swal from "sweetalert2";
import DeleteIcon from '@mui/icons-material/Delete';
import axiosInstance from "../../../axiosInstance";
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import CustomerForm from "./CustomerForm";
import BillPdfDocument, { downloadPDF } from "../../pdf/PDFBill";

const OrderLandingPage = () => {
    const [hotelID,] = useState(localStorage.getItem("billing_app_hotel"));
    const [data, setData] = useState([]);
    const [hoteldata, setHotelData] = useState([]);
    const [foodData, setFoodData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [roomData, setRoomData] = useState([]);
    const [open, setOpen] = useState(false);
    const [foodPopupOpen, setFoodPopupOpen] = useState(false);
    const [selectedFoodItems, setSelectedFoodItems] = useState([]);
    const [currentOrder, setCurrentOrder] = useState(null);
    const [billData, setBillData] = useState(null);
    const userType = localStorage.getItem("billing_app_type");
    const showRoom = userType === "Hotel and Restaurant";

    const initialValues = {
        name: "",
        price: "",
        description: "",
        hotel: hotelID,
        table: "",
        room: ""
    };
    const [inputData, setInputData] = useState(initialValues);

    const customerIntitialValues = {
        name: "",
        email: "",
        phone: "",
        payment_mode: "Cash"
    };
    const [customerInputData, setCustomerInputData] = useState(customerIntitialValues);
    const [errors, setErrors] = useState(customerIntitialValues);
    const [showCustomer, setShowCustomer] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getHotelData();
        getData();
        //eslint-disable-next-line
    }, []);

    const toBase64 = async (url) => {
        const res = await fetch(url);
        const blob = await res.blob();

        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result); // base64 string
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };

    const getHotelData = async () => {
        try {
            const res = await axiosInstance.get('/api/profile/');
            const user = res?.data;
            const logoUrl = user?.hotel_detail?.logo;

            if (logoUrl) {
                const base64Logo = await toBase64(logoUrl);
                user.hotel_detail.logoBase64 = base64Logo;
            }

            setHotelData(user);
        } catch (err) {
            console.error('Failed to fetch hotel data', err);
        }
    };

    const getData = () => {
        axiosInstance(`/api/table/?hotel=${hotelID}&status=free`, {
            method: "GET"
        }).then(res => {
            setTableData(res.data);
        }).catch(err => {
            console.log(err);
        });
        axiosInstance(`/api/room/?hotel=${hotelID}&status=occupied`, {
            method: "GET"
        }).then(res => {
            setRoomData(res.data);
        }).catch(err => {
            console.log(err);
        });

        axiosInstance(`/api/order/?hotel=${hotelID}&active=true`, {
            method: "GET"
        }).then(res => {
            setData(res.data);
        }).catch(err => {
            console.log(err);
        });

        axiosInstance(`/api/food/?hotel=${hotelID}`, {
            method: "GET"
        }).then(res => {
            setFoodData(res.data);
        }).catch(err => {
            console.log(err);
        });
    };

    const handleChange = (e, foodId) => {
        const { name, value, checked } = e.target;

        setInputData((prevData) => {
            let updatedItems = [...(prevData.items || [])];

            if (foodId) {
                if (checked) {
                    updatedItems.push({ food: foodId, quantity: 1 });
                } else {
                    updatedItems = updatedItems.filter((item) => item.food !== foodId);
                }
            } else {
                updatedItems = updatedItems.map((item) =>
                    item.food === parseInt(name) ? { ...item, quantity: parseInt(value) } : item
                );
            }

            return { ...prevData, items: updatedItems };
        });
    };

    const handleClose = () => {
        setOpen(false);
        setInputData(initialValues);
    };

    const handleSubmit = () => {
        // Validate order before submission
        if (!inputData.table && !inputData.room) {
            Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                text: 'Please select either a table or a room for the order.',
            });
            return;
        }

        if (!inputData.items || inputData.items.length === 0) {
            Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                text: 'Please select at least one food item for the order.',
            });
            return;
        }

        let api = inputData?.id ? `/api/order/${inputData.id}/` : `/api/order/`;
        let method = inputData?.id ? "PUT" : "POST";
        axiosInstance(api, {
            method: method,
            data: { ...inputData }
        }).then(res => {
            getData();
            setInputData(initialValues);
            setOpen(false);
            Swal.fire({
                icon: 'success',
                title: inputData?.id ? 'Order updated!' : 'Order created!',
                timer: 1500
            });
        }).catch(err => {
            let errorMessage = 'Failed to save order';
            if (err?.response?.data) {
                if (typeof err.response.data === 'string') {
                    errorMessage = err.response.data;
                } else if (err.response.data.detail) {
                    errorMessage = err.response.data.detail;
                } else if (err.response.data.non_field_errors) {
                    errorMessage = Array.isArray(err.response.data.non_field_errors)
                        ? err.response.data.non_field_errors.join(', ')
                        : err.response.data.non_field_errors;
                } else if (err.response.data.items) {
                    errorMessage = Array.isArray(err.response.data.items)
                        ? err.response.data.items.join(', ')
                        : err.response.data.items;
                } else {
                    errorMessage = JSON.stringify(err.response.data);
                }
            }
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: errorMessage,
            });
        });
    };

    const handleClick = (res) => {
        setOpen(true);
        setInputData(res);
    };

    const handleFoodPopupOpen = (foodItems) => {
        setSelectedFoodItems(foodItems);
        setFoodPopupOpen(true);
    };

    const handleDelete = (e, id) => {
        e?.stopPropagation();
        Swal.fire({
            title: "Are you sure?",
            text: "Are you sure want to delete this Order?",
            showDenyButton: false,
            showCancelButton: true,
            showConfirmButton: true,
            cancelButtonText: "Cancel",
            confirmButtonText: "Delete Order",
            icon: 'warning',
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                axiosInstance(`/api/order/${id}/`, {
                    method: "DELETE"
                }).then(res => {
                    getData();
                    Swal.fire({
                        icon: 'success',
                        title: 'Deleted!',
                        text: 'Order has been deleted successfully',
                        showConfirmButton: true,
                        timer: 1500
                    });
                }).catch(err => {
                    console.log(err);
                });
            }
        });
    };

    const validate = (fieldValues) => {
        let temp = { ...errors };
        if ("name" in fieldValues) {
            temp.name = fieldValues.name === "" || null ? "Name is required" : "";
        }
        if ("email" in fieldValues) {
            temp.email = fieldValues.email !== "" ?
                /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(fieldValues.email)
                    ? "" : "Enter Valid Email" : "";
        }
        if ("phone" in fieldValues) {
            temp.phone = fieldValues.phone !== "" ?
                fieldValues?.phone.toString() !== "" &&
                    !fieldValues?.phone
                        ?.toString()
                        ?.match(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/)
                    ? "Invalid Mobile Number."
                    : "" : "";
        }
        setErrors({ ...temp });
        return Object.values(temp).every((x) => x === "");
    };

    const handleCustomerChange = (e) => {
        setCustomerInputData({ ...customerInputData, [e.target.name]: e.target.value });
    };

    const handlePrint = (e, item) => {
        e?.stopPropagation();
        setCurrentOrder(item);
        setShowCustomer(true);
    };

    const handleCustomerSubmit = () => {
        if (validate(customerInputData)) {
            // Calculate totalAmount properly
            const totalAmount = currentOrder?.items?.reduce((sum, item) => {
                const food = currentOrder?.food_items?.find(f => f.id === item.food);
                return sum + (food ? food.price * item.quantity : 0);
            }, 0);

            setLoading(true);

            axiosInstance("/api/bill/", {
                method: "POST",
                data: {
                    // Backend calculates total_amount from order items, but we send it for reference
                    total_amount: totalAmount,
                    customer_name: customerInputData?.name,
                    customer_phone: customerInputData?.phone,
                    customer_email: customerInputData?.email,
                    payment_mode: customerInputData?.payment_mode || "Cash",
                    order: currentOrder?.id
                }
            }).then(async res => {
                const data = res.data;
                setBillData(data);
                getData();
                // 👇 pass currentOrder to downloadPDF
                await downloadPDF(data, currentOrder, hoteldata);
                Swal.fire({
                    icon: 'success',
                    title: 'Bill generated successfully!',
                    timer: 1500
                });
            }).catch(err => {
                let errorMessage = 'Failed to generate bill';
                if (err?.response?.data) {
                    if (typeof err.response.data === 'string') {
                        errorMessage = err.response.data;
                    } else if (err.response.data.detail) {
                        errorMessage = err.response.data.detail;
                    } else if (err.response.data.non_field_errors) {
                        errorMessage = Array.isArray(err.response.data.non_field_errors)
                            ? err.response.data.non_field_errors.join(', ')
                            : err.response.data.non_field_errors;
                    } else {
                        errorMessage = JSON.stringify(err.response.data);
                    }
                }
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: errorMessage,
                });
            }).finally(() => {
                setLoading(false);
            });
        }
    };


    const handleCustomerClose = () => {
        setCustomerInputData(customerIntitialValues);
        setErrors(customerIntitialValues);
        setShowCustomer(false);
        setBillData(null);
    };

    return (
        <Base>
            <Popup
                open={open}
                handleClose={handleClose}
                title={"Food"}
                handleSubmit={handleSubmit}
                save={(inputData?.items?.length > 0) && (inputData?.table !== "" || inputData?.room !== "")}
                maxWidth="md"
            >
                <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle1" sx={{ mb: 1 }}>Select Table:</Typography>
                    <Select
                        name="table"
                        value={inputData.table || ""}
                        onChange={(e) => setInputData({ ...inputData, table: e.target.value })}
                        size="small"
                        sx={{ width: "100%" }}
                        disabled={inputData?.id}
                    >
                        {tableData.map((table) => (
                            <MenuItem key={table.id} value={table.id}>
                                {table.name}
                            </MenuItem>
                        ))}
                    </Select>
                </Box>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle1" sx={{ mb: 1 }}>Select Room:</Typography>
                    <Select
                        name="room"
                        value={inputData.room || ""}
                        onChange={(e) => setInputData({ ...inputData, room: e.target.value })}
                        size="small"
                        sx={{ width: "100%" }}
                        disabled={inputData?.id}
                    >
                        {roomData.map((room) => (
                            <MenuItem key={room.id} value={room.id}>
                                {room.no}
                            </MenuItem>
                        ))}
                    </Select>
                </Box>
                <Cart table={tableData} item={foodData} handleChange={handleChange} inputData={inputData} />
            </Popup>

            <Popup
                open={foodPopupOpen}
                handleClose={() => setFoodPopupOpen(false)}
                title={"Food Items"}
                isSave={false}
                maxWidth="md"
            >
                {selectedFoodItems.length > 0 ? (
                    <List>
                        {selectedFoodItems.map((item, index) => (
                            <ListItem key={index}>
                                <ListItemText primary={`${index + 1}. ${item.name} - ${item.quantity}`} />
                            </ListItem>
                        ))}
                    </List>
                ) : (
                    <Typography variant="body2">No food items available.</Typography>
                )}
            </Popup>

            <Popup
                open={showCustomer}
                handleClose={handleCustomerClose}
                title={"Customer Information"}
                handleSubmit={handleCustomerSubmit}
                maxWidth="sm"
                saveText="Generate Bill"
            >
                <CustomerForm handleChange={handleCustomerChange} inputData={customerInputData} errors={errors} />
            </Popup>

            <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", mb: 2 }}>
                <Button 
                    variant="contained" 
                    onClick={() => setOpen(true)}
                    size="small"
                    sx={{ 
                        borderRadius: 1.5,
                        px: 2,
                        py: 0.75,
                        textTransform: 'none',
                        fontWeight: 600,
                        boxShadow: '0 2px 8px rgba(139, 68, 255, 0.3)',
                        '&:hover': {
                            boxShadow: '0 4px 12px rgba(139, 68, 255, 0.4)',
                            transform: 'translateY(-1px)',
                        },
                        transition: 'all 0.3s ease',
                    }}
                >
                    Create Order
                </Button>
            </Box>

            <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                    {data?.length > 0 ? (
                        data?.map((res) => {
                            const foodItems = res?.food_items || [];
                            return (
                                <Grid item xs={12} sm={6} md={3} key={res.id}>
                                    <Card
                                        variant="outlined"
                                        orientation="horizontal"
                                        sx={{
                                            width: "100%",
                                            maxWidth: 320,
                                            "&:hover": { 
                                                boxShadow: '0 4px 12px rgba(139, 68, 255, 0.15)',
                                                borderColor: "primary.main",
                                                transform: "translateY(-3px)",
                                            },
                                            display: "flex",
                                            flexDirection: "column",
                                            marginTop: "0.75rem",
                                            padding: "1.25rem",
                                            cursor: "pointer",
                                            borderRadius: 2,
                                            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                            border: '1px solid rgba(0, 0, 0, 0.08)',
                                            boxShadow: '0 1px 4px rgba(0, 0, 0, 0.08)',
                                        }}
                                        onClick={() => handleClick(res)}
                                    >
                                        <Box sx={{ mt: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <Typography variant="h6">
                                                {res?.table_info
                                                    ? `Table - ${res?.table_info?.name}`
                                                    : `Room - ${res?.room_info?.no}`}
                                            </Typography>
                                            <Box>
                                                <Tooltip title="Generate Bill">
                                                    <LocalPrintshopIcon fontSize="small" color="primary" onClick={(e) => handlePrint(e, res)} />
                                                </Tooltip>
                                                <Tooltip title="Delete">
                                                    <DeleteIcon fontSize="small" style={{ color: "red" }} onClick={(e) => handleDelete(e, res.id)} />
                                                </Tooltip>
                                            </Box>
                                        </Box>
                                        {
                                            showRoom && res?.room_info &&
                                            <Box sx={{ mt: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                <Typography variant="h6">{`Room - ${res?.room_info?.no}`}
                                                </Typography>
                                            </Box>
                                        }
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            <Typography variant="body2" sx={{ fontSize: "0.85rem", flexGrow: 1 }}>
                                                {foodItems.length > 0 ? (
                                                    <>
                                                        {foodItems.slice(0, 2).map((item, index) => (
                                                            <span key={index}>
                                                                {item.name} - {item.quantity}
                                                                {index !== foodItems.slice(0, 2).length - 1 ? ", " : ""}
                                                            </span>
                                                        ))}
                                                        {foodItems.length > 2 && (
                                                            <Button size="small" sx={{ ml: "3px", minWidth: "auto", textTransform: "none" }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleFoodPopupOpen(foodItems);
                                                                }}>
                                                                View More
                                                            </Button>
                                                        )}
                                                    </>
                                                ) : (
                                                    "No food items available."
                                                )}
                                            </Typography>
                                        </Box>
                                    </Card>
                                </Grid>
                            );
                        })
                    ) : ""}
                </Grid>
            </Box>
            {data?.length === 0 && (
                <Box 
                    sx={{ 
                        mt: 8, 
                        textAlign: "center",
                        py: 8,
                    }}
                >
                    <Typography 
                        variant="h5" 
                        sx={{ 
                            color: 'text.secondary',
                            mb: 2,
                            fontWeight: 500,
                        }}
                    >
                        No orders yet
                    </Typography>
                    <Typography 
                        variant="body1" 
                        sx={{ 
                            color: 'text.secondary',
                            mb: 4,
                        }}
                    >
                        Create your first order to start serving customers
                    </Typography>
                    <Button 
                        variant="contained" 
                        onClick={() => setOpen(true)}
                        sx={{
                            borderRadius: 2,
                            px: 4,
                            py: 1.5,
                            textTransform: 'none',
                            fontWeight: 600,
                        }}
                    >
                        Create New Order
                    </Button>
                </Box>
            )}
        </Base>
    );
};

export default OrderLandingPage;